import React from "react";
import { useTranslation } from "react-i18next";

const PaymentExpiredCard: React.FC = () => {
  const { t } = useTranslation("paymentPage");

  return (
    <div className="bg-white min-h-screen flex flex-col items-center justify-center px-6">
      {/* Illustration */}
      <div>
        <img src="/road-closed-taxi.svg" alt="Payment Expired" className="w-48 h-48" />
      </div>

      {/* Message */}
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          {t("timeLimitExceeded")}
        </h2>
        <p className="text-gray-600 text-lg leading-relaxed max-w-sm">
          {t("askDriverNewQR")}
        </p>
      </div>
    </div>
  );
};

export default PaymentExpiredCard;
